import React, { useState } from 'react';
import { Info, TuneOutlined } from '@mui/icons-material';
import { Stack, Typography, IconButton, useTheme, ToggleButtonGroup, ToggleButton } from '@mui/material';
import ChatDisclaimer from './ChatDisclaimer';

interface HeaderProps {
  title: string;
  onCompact: () => void;
  onStandard: () => void;
  compactOrStandard: string;
  settingsMenu: JSX.Element;
  setMenuAnchorEl: (anchorEl: HTMLElement | null) => void;
}

const Header = ({
  title,
  onCompact,
  onStandard,
  compactOrStandard,
  settingsMenu,
  setMenuAnchorEl,
}: HeaderProps): JSX.Element => {
  const theme = useTheme();
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchorEl(event.currentTarget);
  };

  return (
    <Stack
      direction="row"
      alignItems="center"
      gap={2}
      padding={2}
      sx={{ borderBottom: '1px solid #e0e0e0', height: '64px' }}>
      <Typography variant="h6" sx={{ width: '5em' }}>
        {title}
      </Typography>
      <IconButton onClick={handleMenuClick} size="small">
        <TuneOutlined />
      </IconButton>
      {settingsMenu}
      <ToggleButtonGroup
        color="secondary"
        value={compactOrStandard}
        exclusive
        sx={{
          height: '37px',
        }}
        onChange={(event, value) => {
          if (value === 'compact') {
            onCompact();
          } else if (value === 'standard') {
            onStandard();
          }
        }}>
        <ToggleButton value="compact">
          <Typography variant="body2" sx={{ textTransform: 'none' }}>
            Compact
          </Typography>
        </ToggleButton>
        <ToggleButton value="standard">
          <Typography variant="body2" sx={{ textTransform: 'none' }}>
            Standard
          </Typography>
        </ToggleButton>
      </ToggleButtonGroup>
      <Stack direction="row" alignItems="center" gap={1} flexGrow={1} justifyContent="flex-end">
        <ChatDisclaimer />
      </Stack>
    </Stack>
  );
};

export default Header;
